const globalData = {
  data: {
    floors: []
  },
};

export default globalData;
